import { Grid } from '@mantine/core';
import { FormAccordion, FormAccordionItem } from 'src/UI/dynamicUI/layout/DynamicEntitySection';
import { ProductFormComponentProps } from 'src/financial/financial-data/financial-item/forms/common/FinancialFormHelpers';
import { FinancialFormField } from 'src/financial/financial-data/financial-item/forms/common/FinancialFormField';
import { GenericFinancialItemFormWrapper } from 'src/financial/financial-data/financial-item/forms/GenericFinancialItemFormWrapper';
import { GridPair } from 'src/financial/financial-data/financial-item/forms/common/GridPair';

const STATE_PENSION = 'StatePension';

export function StatePension(props: ProductFormComponentProps) {
  return (
    <GenericFinancialItemFormWrapper
      title={'Assets > Pensions > State Pension'}
      {...props}
      product={STATE_PENSION}
    >
      <FormAccordion defaultValue={['summary', 'forecast', 'components', 'payment']}>
        <FormAccordionItem value="summary" label="Summary">
          <Grid>
            <GridPair
              first={<StatePensionField field="description" />}
              second={<StatePensionField field="status" />}
            />
            <GridPair
              first={<StatePensionField field="type" />}
              second={<StatePensionField field="state_pension_date" />}
            />
            <GridPair first={<StatePensionField field="is_serviced_by_advisor" forceEditable />} />
            <GridPair fullWidth first={<StatePensionField field="notes" />} />
          </Grid>
        </FormAccordionItem>

        <FormAccordionItem value="forecast" label="Forecast">
          <Grid>
            <GridPair
              isHighlighted
              first={<StatePensionField field="forecast_weekly_amount" />}
              second={<StatePensionField field="accrued_weekly_amount" />}
            />
            <GridPair
              first={<StatePensionField field="forecast_date" />}
              second={<StatePensionField field="accrued_as_at_date" />}
            />
            <GridPair
              first={<StatePensionField field="qualifying_years" />}
              second={<StatePensionField field="gap_years_fillable" />}
            />
          </Grid>
        </FormAccordionItem>

        <FormAccordionItem value="components" label="Entitlement breakdown (per week)">
          <Grid>
            <GridPair
              first={<StatePensionField field="basic_weekly_amount" label="Basic component" />}
              second={
                <StatePensionField field="additional_weekly_amount" label="Additional component" />
              }
            />
            <GridPair
              first={
                <StatePensionField
                  field="protected_payment_weekly_amount"
                  label="Protected payment"
                />
              }
              second={<StatePensionField field="cope_weekly_amount" label="COPE amount" />}
            />
            <GridPair
              first={<StatePensionField field="inherited_weekly_amount" label="Inherited amount" />}
            />
          </Grid>
        </FormAccordionItem>

        <FormAccordionItem value="payment" label="In payment and deferral">
          <Grid>
            <GridPair
              isHighlighted
              first={<StatePensionField field="annual_amount" label="Annual amount" />}
              second={
                <StatePensionField field="annual_amount_applicable_date" label="Applicable date" />
              }
            />
            <GridPair
              first={<StatePensionField field="deferral_start_date" />}
              second={
                <StatePensionField
                  field="deferral_uplift_weekly_amount"
                  label="Deferral uplift (per week)"
                />
              }
            />
            <GridPair first={<StatePensionField field="deferral_lump_sum" />} />
          </Grid>
        </FormAccordionItem>
      </FormAccordion>
    </GenericFinancialItemFormWrapper>
  );
}

type StatePensionFieldProps = {
  label?: string;
  field: string;
  forceEditable?: boolean;
};

const StatePensionField = ({ label, field, forceEditable }: StatePensionFieldProps) => (
  <FinancialFormField
    label={label}
    field={field}
    product={STATE_PENSION}
    forceEditable={forceEditable}
  />
);
